export default {
	methods: {
		async uploadBase64File(base64, filename = "image.jpg", type = "image/jpeg") {
			if (this.$refs.manager && typeof this.$refs.manager.uploadBase64File === "function") {
				return this.$refs.manager.uploadBase64File(base64, filename, type)
			}
		}
	}
}
